import React, {memo} from 'react';
import styled from "styled-components";

const CubeWrapperStyled = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  font-size: 0;
`;

const CubeItemrStyled = styled.div`
  border-left: 1px solid rgba(128, 128, 137, 0.2);
  border-top: 1px solid rgba(128, 128, 137, 0.2);
  display: inline-block;
  margin: 0 0 0 0;
  padding: 0;
  line-height: 0;
  box-sizing: border-box;
  font-size: 0;
  letter-spacing: 0;
`;


const TestSensorGrid = ({numberOfCubes, divider, hoveredItemCube, xItems, yItems}) => {
    return (
        <CubeWrapperStyled>
            {[...Array(yItems)].map((po, idx) => {
                return ([...Array(xItems)].map((pi, idy) => {
                    return (
                        <CubeItemrStyled
                            style={{width: divider, height: divider}}
                            key={'lop' + idy}
                            onMouseEnter={() => {
                                hoveredItemCube(idx, idy);
                            }}
                            onMouseLeave={() => {
                                hoveredItemCube(null);
                            }}
                        />
                    );
                }));
            })}
        </CubeWrapperStyled>
    );
};

export default memo(TestSensorGrid, ((prev, next) => {
    return prev.numberOfCubes === next.numberOfCubes && prev.divider === next.divider;
}));